import React, {useEffect, useState} from 'react';
import {Button, message, Tooltip, Upload} from 'antd';
import styles from './layout.module.less'
import store from "../store";
import axios from "axios";
import {observer} from 'mobx-react';
import FormItem from './FormItem'
import RowItem from './RowItem'
import { PlusSquareFilled,PlusOutlined, UploadOutlined, CloseOutlined  } from '@ant-design/icons';

// the hook
import {useTranslation} from 'react-i18next';
import FileImg from './wenjian.png';

function FormRow() {
  const {t} = useTranslation();
  const [num, setNum] = useState(1)
  const [records, setRecords] = useState([])
  const record = {
    brand: ""
    , createdAt: ""
    , customerId: 0
    , deliveryDate: null
    , desc: ""
    , extraSn: null
    , factoryCode: ""
    , formats: ""
    , id: ''
    , isMeasure: false
    , name: ""
    , number: 1
    , product_id: null
    , catalog: 'Sale'
    , isEdit: true
  }

  const addRow = () => {
    if (store.userAddRecords?.length<10) {
      let cur = {...record}
      setNum(num + 1)
      cur.uid = num + Math.random()
      store.userAddRecords.push(cur)
    }else{
      message.error('最多只能添加10行！')
    }
  }

  const uploadFile = (file) => {
    store.authFileUrl({"fileName": file.file.name, "contentType": file.file.type,'catalog':'inquiry-attachment'}).then(res=>{
      store.file = res.data;
      axios.put(store.file.result, file.file, {
        headers: {
          'Content-Type': file.file.type
        },
      }).then((res) => {
        store.userAddRecords = store.userAddRecords.map((item)=>{
          item.name = '1';
          item.formats = '1';
          item.uid = num + Math.random();
          return item;
        })
        message.success('上传成功！')
      })
    })
  }

  const getFile = () => {
    store.getFile({filePath:store.file.filePath}).then((res)=>{
      window.open(res.data.result)
    });
  }
  
  const deleteFile = () => {
    store.deleteFile({filePath:store.file.filePath}).then((res)=>{
      store.file = {};
      message.success('删除成功！')
    });
  }

  useEffect(()=>{
    setRecords(store.userAddRecords);
  },[store.userAddRecords])

  return (
    <React.Fragment>
      <div className={styles.addArea}>
         <div className={styles.innerTitle}>
          <div className={styles.innerLeft}>
            <span className={styles.tipOne}>{t('如您需要的商品不在商城中，可填写一下信息：')}</span>
            <span>{t('* 请尽可能填写详细，以便我们更好的为您提供服务。')}</span>
          </div>
          {/* <Tooltip placement="top" title={'添加'}> */}
            <div className={styles.innerRight} onClick={addRow}>
              {/* <PlusSquareFilled className='plusBtn'/> */}
              <Button type="primary" className='plusBtn' icon={<PlusOutlined />}>
                新增一行
              </Button>
            </div>
          {/* </Tooltip> */}
          <Upload 
            showUploadList={false}
            maxCount={1}
            data={{ path: "inquiry-attachment" }}
            headers={{ 'X-Token': localStorage.getItem('token') }}
            action={store.file.result}
            // beforeUpload={handleBeforeUpload}
            customRequest={uploadFile}
            >
            {/* <Tooltip placement="top" title={'上传附件'}> */}
                <div className={styles.innerRight}>
                  {/* <UploadOutlined className='uploadBtn'/> */}
                  <Button type="primary" className='uploadBtn' icon={<UploadOutlined />}>
                    上传附件
                  </Button>
                </div>
            {/* </Tooltip> */}
          </Upload>
        </div>
        {        
            store.file.fileName?
            <div className={styles.fileList}>
              <div className='fileName' onClick={getFile}>
                <img src={FileImg} alt="" />
                <span>{store.file.fileName}</span>
              </div>
              <div className='closeBtn' onClick={deleteFile}>
                <CloseOutlined />
              </div>
            </div>
            :
            <div className={styles.emptyFile}></div>
        }
        {
          records.map((item, index) => {
            return <div key={item.id ? item.id : item.uid}><FormItem record={item} index={index}/></div>
            // if (item.isEdit) {
            //   return <div key={item.id ? item.id : item.uid}><FormItem record={item} index={index}/></div>
            // } else {
            //   return <div key={item.id ? item.id : item.uid}><RowItem record={item} index={index}/></div>
            // }

          })
        }
      </div>
    </React.Fragment>
  )
}

export default observer(FormRow)
